import gql from 'graphql-tag';

import lightFields from '@/queries/fields/lightFields';
import groupFields from './fields/groupFields';
import { LightModeFields } from './fields/lightModeFields';

export const roomGroupsAndLightsQuery = gql`
  query room($roomId: String!) {
    room(id: $roomId) {
      id
      groups {
        ...groupFields
      }
      lights {
        ...lightFields
      }
    }
  }
  ${groupFields}
  ${lightFields}
`;

export const lightIdsInRoomQuery = gql`
  query room($id: String!) {
    room(id: $id) {
      id
      lights {
        id
      }
    }
  }
`;

export namespace RoomWithDimmingForLights {

  export const query = gql`
    query room($id: String!) {
      room(id: $id) {
        id
        lights {
          id
          currentState {
            dimming
          }
        }
      }
    }
  `;

  export interface Definition {
    room: {
      id: string;
      lights: {
        id: string;
        currentState: {
          dimming: number;
        };
      }[];
    };
  }

}

export namespace RoomWithLightModeForLights {

  export const query = gql`
    query room($id: String!) {
      room(id: $id) {
        id
        lights {
          id
          currentState {
            mode {
              ...lightModeFields
            }
          }
        }
      }
    }
    ${LightModeFields.fragment}
  `;

  export interface Definition {
    room: {
      id: string;
      lights: {
        id: string;
        currentState: {
          mode: LightModeFields.Definition;
        };
      }[];
    };
  }

}

export namespace RoomWithFanStateForLights {

  export const query = gql`
    query room($id: String!) {
      room(id: $id) {
        id
        lights {
          id
          currentState {
            fanState
          }
        }
      }
    }
  `;

  export interface Definition {
    room: {
      id: string;
      lights: {
        id: string;
        currentState: {
          fanState: boolean;
        };
      }[];
    };
  }

}
